import { defineComponent } from '@vue/composition-api'
import { i18n } from '@/utilities/vue-i18n';
import { MenuItem } from './settings-types'
import {createPageContext} from "@/components/navbar-box/page-context";

export default defineComponent({

  setup() {

    const items = [
      {
        title: i18n.t('pages.settings.menu1Item1'),
        route: 'Company Info',
        icon: 'business'
      },
      {
        title: i18n.t('pages.settings.company-profile'),
        route: 'Profile For Company',
        icon: 'web'
      },
      {
        title: i18n.t('pages.settings.menu1Item3'),
        route: 'User Management',
        icon: 'users'
      },
      {
        title: i18n.t('pages.settings.menu1Item4'),
        route: 'Connections',
        icon: 'connections'
      },
      {
        title: i18n.t('pages.settings.billing'),
        route: 'Billing',
        icon: 'invoices'
      },
      {
        title: i18n.t('pages.settings.api-keys'),
        route: 'API Keys',
        icon: 'api-keys'
      },
    ] as MenuItem[];

    const pageContext = createPageContext({
      actions: [],
      title: {text: ''},
      breadcrumb: {
        showHome: false,
        segments: [
          {text: i18n.t('home.breadcrumb-settings') as string, icon: '<i class="mdi mdi-office-home-cog"></i>'}
        ]
      }
    });

    return {
      items,
      pageContext
    }
  }
})
